module.exports = __webpack_public_path__ + "static/media/FUSE Network.ce1ccf55.svg";